import React from 'react';
import { twMerge } from 'tailwind-merge';

import { LegacyVideo as Video } from '@videoblocks/storywind';

import StockItemIcons from '../../app/Search/components/card/StockItemIcons';
import { posterPlaceholderDataUri } from '../../common/Constants';

import './VideoStockItemPreview.less';

interface Props {
  previewUrl: string;
  shouldStockItemHaveNewFlag: boolean;
  title?: string;
  className?: string;
  // String taking the form `"<int> x <int>"`
  resolution?: string;
  isVertical?: boolean;
}

/**
 * Convert a resolution string (e.g. `"1920 x 1080"`) into a percentage.
 * The percentage represents the ratio of height to width.
 * @param resolution
 */
export function resolutionStringToPercentage(
  resolution: string,
  isVertical: boolean
): number {
  const [, width, height] = /^(\d+)[ x]+(\d+)$/.exec(resolution) || [
    null,
    isVertical ? 9 : 16,
    isVertical ? 16 : 9,
  ];
  let percentage: number;

  if (isVertical) {
    percentage = (Number(width) / Number(height)) * 100;
  } else {
    percentage = (Number(height) / Number(width)) * 100;
  }
  return percentage;
}

const VideoStockItemPreview = ({
  previewUrl,
  shouldStockItemHaveNewFlag,
  title,
  className,
  resolution,
  isVertical,
}: Props) => (
  <div
    className={twMerge('VideoStockItemPreview', 'relative', className)}
    role="region"
    aria-label={title}
    itemType="schema.org/VideoObject"
  >
    <div
      style={{
        paddingTop: `${resolutionStringToPercentage(resolution, isVertical)}%`,
      }}
    />
    <StockItemIcons showNewFlag={shouldStockItemHaveNewFlag} />
    <div className="absolute inset-0 w-full h-full overflow-hidden rounded-t-xl xl:rounded-tr-none">
      <Video
        className="w-full h-full"
        videoUrl={previewUrl}
        showControls
        autoPlay
        poster={posterPlaceholderDataUri}
      />
    </div>
  </div>
);

export default VideoStockItemPreview;
